function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers, Array, JSON, Object, String, delayRemove, description) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const {
      header,
      editItem,
      headerLink,
      isUnsaved,
      subheader,
      details,
      metrics,
      compositionDef,
      actions,
      lookupTableName,
      lookupTableIsTempMapping,
      helpLink,
      includeAutotrackDeprecationWarning
    } = $helpers.getDisplayData();;
    const MAX_DESCRIPTION_LENGTH = 300;;
    return {
      value: (h("div", {
        "class": {
          'wrapper': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($helpers.shouldShow()) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "on": {
              mouseenter: $helpers.handleMouseEnter,
              mouseleave: $helpers.handleMouseLeave,
            },
            "class": Object.assign({}, {
              delayed: {
                'tooltip-in': true
              },
              remove: {
                'tooltip-out': true,
                delayRemove
              },
            }, {
              'root': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'container': true
              },
            }, (function() {
              var __jade_nodes = []; /*  We only want to show the warning once the banner is up */
              /*  This is just a switch to make it easy to do */
              const isAutotrackDeprecationBannerOn = false;
              __jade_nodes = __jade_nodes.concat((isAutotrackDeprecationBannerOn && includeAutotrackDeprecationWarning) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'autotrack-warning': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-banner", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      theme: `warn`,
                      size: `small`,
                      "body-text": "This event will not be ingested after Jan 11, 2020. [Learn more](https://help.mixpanel.com/hc/en-us/articles/115004600343)",
                      type: `embedded`,
                    }),
                  }));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'header': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((headerLink) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("a", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      href: headerLink,
                      target: "_blank"
                    }),
                    "class": {
                      'header-link': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(header);
                    __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        icon: `caret-right`
                      }),
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat((isUnsaved) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("i", [__vjadeSafeCode(` (Temp)`)]));;
                    return __jade_nodes
                  }).call(this)) : undefined);;
                  return __jade_nodes
                }).call(this)) : ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(header);;
                  return __jade_nodes
                }).call(this)));
                __jade_nodes = __jade_nodes.concat((isUnsaved) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("i", [__vjadeSafeCode(` (Temp)`)]));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat((subheader) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'subheader': true
                  },
                }, [__vjadeSafeCode(subheader)]));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'description': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((editItem) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((!description.isEditing) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "on": {
                        click: () => !description.text ? $helpers.handleTextEditorEditingStart() : null
                      },
                      "class": {
                        'description-text-wrapper': true,
                        'description-empty': !description.text
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((description.text) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat($helpers.formatText(description.text, {
                          className: `description-text`,
                          maxLength: MAX_DESCRIPTION_LENGTH
                        }));;
                        return __jade_nodes
                      }).call(this)) : ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "on": {
                            click: $helpers.handleTextEditorEditingStart
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(`+ Add Description...`);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)));
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'editable-icon': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-button", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            icon: `edit`,
                            theme: `tertiary`
                          }),
                          "on": {
                            click: $helpers.handleTextEditorEditingStart
                          },
                          "class": {
                            'edit-description-button': true
                          },
                        }));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-input", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        type: `textarea`,
                        value: description.text,
                        placeholder: `Please add a description`,
                      }),
                      "on": {
                        input: $helpers.handleTextEditorValueChange,
                        blur: (ev) => $helpers.handleTextEditorSave(ev, editItem),
                        keydown: (ev) => $helpers.handleKeyPressToSave(ev, editItem),
                      },
                      "props": {
                        value: description.text,
                      },
                      "hook": {
                        insert: $helpers.handleTextEditorInserted
                      },
                      "class": {
                        'description-editor': true
                      },
                    }));;
                    return __jade_nodes
                  }).call(this)));;
                  return __jade_nodes
                }).call(this)) : ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'description-text-nonedit': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat($helpers.formatText(description.text, {
                      className: `description-text`,
                      maxLength: MAX_DESCRIPTION_LENGTH
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              const hasCompositionDefParts = compositionDef && compositionDef.parts;;
              __jade_nodes = __jade_nodes.concat((hasCompositionDefParts) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'composition': true,
                    'section': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'name': true
                    },
                  }, [__vjadeSafeCode(compositionDef.name)]));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'value': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-custom-event-composition", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        'composition-parts': JSON.stringify(compositionDef.parts),
                      }),
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat((metrics && metrics.length) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'metrics': true,
                    'section': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((function() {
                    var $$obj = (metrics);
                    var $$eachNodes;
                    var $$iterated = false;
                    if (Array.isArray($$obj)) {
                      $$eachNodes = $$obj.reduce(function($$eachNodes, metric, $index) {
                        $$iterated = true;
                        return $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'metric': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-text-highlight", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                text: metric.value,
                                theme: 'neutral'
                              }),
                            }));
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'name': true
                              },
                            }, [__vjadeSafeCode(metric.name)]));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                      }, []);
                    } else {
                      $$eachNodes = [];
                      for (var $$objKey in $$obj) {
                        (function() {
                          var $index = $$objKey;
                          if ($$obj.hasOwnProperty($index)) {
                            $$iterated = true;
                            var metric = $$obj[$index];
                            $$eachNodes = $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'metric': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("mp-text-highlight", {
                                  "attrs": __vjadeStringifyAttrsIfObj({
                                    text: metric.value,
                                    theme: 'neutral'
                                  }),
                                }));
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'name': true
                                  },
                                }, [__vjadeSafeCode(metric.name)]));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this));
                          }
                        })();
                      }
                    }

                    return $$eachNodes;
                  })());;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat((actions && actions.length) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((function() {
                  var $$obj = (actions);
                  var $$eachNodes;
                  var $$iterated = false;
                  if (Array.isArray($$obj)) {
                    $$eachNodes = $$obj.reduce(function($$eachNodes, action, $index) {
                      $$iterated = true;
                      return $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'button-container': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-button", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              theme: `secondary`,
                              icon: action.icon || ``,
                              disabled: action.disabled,
                              href: action.href,
                              elref: action.label
                            }),
                            "on": {
                              click: ev => $helpers.actionClick(ev, action),
                            },
                            "class": {
                              'edit-button': true
                            },
                          }, [__vjadeSafeCode(action.label)]));
                          __jade_nodes = __jade_nodes.concat((action.disabled && action.disabledTooltipText) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                placement: 'right'
                              }),
                              "class": {
                                'edit-tooltip': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(action.disabledTooltipText);;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)) : undefined);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this));
                    }, []);
                  } else {
                    $$eachNodes = [];
                    for (var $$objKey in $$obj) {
                      (function() {
                        var $index = $$objKey;
                        if ($$obj.hasOwnProperty($index)) {
                          $$iterated = true;
                          var action = $$obj[$index];
                          $$eachNodes = $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'button-container': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                                "attrs": __vjadeStringifyAttrsIfObj({
                                  theme: `secondary`,
                                  icon: action.icon || ``,
                                  disabled: action.disabled,
                                  href: action.href,
                                  elref: action.label
                                }),
                                "on": {
                                  click: ev => $helpers.actionClick(ev, action),
                                },
                                "class": {
                                  'edit-button': true
                                },
                              }, [__vjadeSafeCode(action.label)]));
                              __jade_nodes = __jade_nodes.concat((action.disabled && action.disabledTooltipText) ? ((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                  "attrs": __vjadeStringifyAttrsIfObj({
                                    placement: 'right'
                                  }),
                                  "class": {
                                    'edit-tooltip': true
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(action.disabledTooltipText);;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this)) : undefined);;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this));
                        }
                      })();
                    }
                  }

                  return $$eachNodes;
                })());;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat((details && details.length) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'separator-line': true
                  },
                }));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'details': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((function() {
                    var $$obj = (details);
                    var $$eachNodes;
                    var $$iterated = false;
                    if (Array.isArray($$obj)) {
                      $$eachNodes = $$obj.reduce(function($$eachNodes, detail, $index) {
                        $$iterated = true;
                        return $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'detail': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": Object.assign({}, {
                                [detail.icon]: true
                              }, {
                                'icon': true
                              }),
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                "attrs": __vjadeStringifyAttrsIfObj({
                                  icon: detail.icon
                                }),
                              }));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));
                            __jade_nodes = __jade_nodes.concat((detail.value) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'value': true
                                },
                              }, [__vjadeSafeCode(detail.value)]));;
                              return __jade_nodes
                            }).call(this)) : undefined);;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                      }, []);
                    } else {
                      $$eachNodes = [];
                      for (var $$objKey in $$obj) {
                        (function() {
                          var $index = $$objKey;
                          if ($$obj.hasOwnProperty($index)) {
                            $$iterated = true;
                            var detail = $$obj[$index];
                            $$eachNodes = $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'detail': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": Object.assign({}, {
                                    [detail.icon]: true
                                  }, {
                                    'icon': true
                                  }),
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                    "attrs": __vjadeStringifyAttrsIfObj({
                                      icon: detail.icon
                                    }),
                                  }));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));
                                __jade_nodes = __jade_nodes.concat((detail.value) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'value': true
                                    },
                                  }, [__vjadeSafeCode(detail.value)]));;
                                  return __jade_nodes
                                }).call(this)) : undefined);;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this));
                          }
                        })();
                      }
                    }

                    return $$eachNodes;
                  })());;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat((helpLink) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("a", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    href: helpLink.href,
                    target: helpLink.target || `_blank`
                  }),
                  "class": {
                    'help-link': true
                  },
                }, [__vjadeSafeCode(helpLink.label)]));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat((lookupTableName) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'dim-prop-detail': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'dim-prop-info': true
                  },
                }, [__vjadeSafeCode(`This property is ${lookupTableIsTempMapping ? `temporarily mapped` : `mapped`} to ${lookupTableName} lookup table`)])); /*  TODO (duc): Replace help url with lookup table doc URLs */
                __jade_nodes = __jade_nodes.concat(h("a", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    href: `https://help.mixpanel.com/hc/en-us/articles/360044139291-Lookup-tables`,
                    target: `_blank`
                  }),
                  "class": {
                    'dim-prop-doc': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("More about Lookup Tables");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "delayRemove" in locals ? locals.delayRemove : typeof delayRemove !== "undefined" ? delayRemove : undefined, "description" in locals ? locals.description : typeof description !== "undefined" ? description : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;